// extracted by mini-css-extract-plugin
export default {"variablesContainer":"variablesContainer__helpArticleVariables__5AvFZ"};